module.exports = __webpack_public_path__ + "img/CS2_section_4_window_view.04f58213.png";